import { useMemo } from 'react';
import useRangeFilter from '@/creditflowresearch/ui/components/corporate-bond-screener/Sidebar/Sections/hooks/useRangeFilter';
import { createRangeSchema } from '@/creditflowresearch/ui/common/hooks/sidebar/rangeSchema';
import useExcludeToggle from '@/creditflowresearch/ui/common/hooks/sidebar/useExcludeToggle';
import {
  useCorporateBondScreenerSidebarFilterContext,
} from '@/creditflowresearch/application/CorporateBondScreener/Sidebar/useCorporateBondScreenerSidebarFilterContext';

const useTenor = () => {
  const { filters } = useCorporateBondScreenerSidebarFilterContext();
  const schema = useMemo(() => createRangeSchema({ bounds: filters?.tenor }), [filters?.tenor]);

  const { isExcluded, onToggleExclude } = useExcludeToggle({
    includeKey: ['includedTenorFrom', 'includedTenorTo'],
    excludeKey: ['excludedTenorFrom', 'excludedTenorTo'],
    stateKey: 'isTenorExcluded',
    useFilterContext: useCorporateBondScreenerSidebarFilterContext,
  });

  const fromKey = isExcluded ? 'excludedTenorFrom' : 'includedTenorFrom';
  const toKey = isExcluded ? 'excludedTenorTo' : 'includedTenorTo';

  const rangeFilter = useRangeFilter({ fromKey, toKey, schema });

  return { ...rangeFilter, isExcluded, onToggleExclude };
};

export default useTenor;
